export default {
  getList: {
    method: 'post',
    url: '/admincp/node/connection/list?nodeId='
  },
  add: {
    method: 'post',
    url: '/admincp/node/connection'
  },
  delete: {
    method: 'delete',
    url: '/admincp/node/connection'
  },
  archive: {
    method: 'delete',
    url: '/admincp/node/connection/archive'
  },
  restore: {
    method: 'put',
    url: '/admincp/node/connection/restore'
  },
  getById: {
    method: 'get',
    url: '/admincp/node/connection/ID'
  },
  edit: {
    method: 'put',
    url: '/admincp/node/connection/ID'
  }
}
